import Page from '../../../shared/components/Page/Page';
import {
    Button,
    Dropdown,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Popconfirm, QRCode,
    Select,
    Segmented,
    Space,
    Table,
    Tag,
    Typography
} from "antd";
import {useContext, useEffect, useState} from "react";
import { getBanks } from "../api";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faArrowsRotate, faMoneyBillTransfer, faRegistered, faTrash} from "@fortawesome/free-solid-svg-icons";
import {
    AccountBookOutlined, AppstoreOutlined, CheckOutlined, DeleteOutlined,
    EditOutlined,
    ExportOutlined,
    LoginOutlined, MobileOutlined, PlusOutlined,
    QrcodeOutlined,
    ReloadOutlined, SearchOutlined,
    TransactionOutlined, UnorderedListOutlined
} from "@ant-design/icons";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {useStyle} from "../../../shared/hooks/useStyle";
import ItemDropDown from "../../../layouts/AppLayout/TopMenu/ItemDropDown/ItemDropDown";
import BankAccountType from "../components/BankAccountType/BankAccountType";
import TextCopy from "../../../shared/components/TextCopy";
import ReadMoreText from "../../../shared/components/ReadMoreText";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import AmountLimit from "../../../shared/components/AmountLimit/AmountLimit";
import CountLimit from "../../../shared/components/CountLimit/CountLimit";
import { addPartner } from "../api";
import { deleteBankAccountPrivate } from "../api";
import { getBankAccountPrivate } from "../api";
import { getBankAccountBusiness } from "../api";
import { confirmBankAccountApprove } from "../api";
import { deleteBankAccount } from "../api";
import { getBankAccountDevice } from "../api";
import { updateBankAccountDevice } from "../api";
import { transfer } from "../api";
import { getBenchName } from "../api";
import { updateBankAccount } from "../api";
import { handle } from "../api";
import { getBankAccounts } from "../api";
import { getBankTransfer } from "../api";
import { searchPartner } from "../../partner/api";
import Search from "../../../shared/components/Search/Search";
import EditTableCell from "../../../shared/components/Table/EditTableCell/EditTableCell";
import BankAccountTransaction from "../components/BankTransaction/BankAccountTransaction";
import BankAccountAuthModal from "../components/BankAccountAuthModal/BankAccountAuthModal";
import BankAccountOtpModal from "../components/BankAccountOtpModal/BankAccountOtpModal";
import BankAccountGrid from "../components/BankAccountGrid/BankAccountGrid";
import FormDrawer from "../../../shared/components/FormDrawer/FormDrawer";
import useBankAccountOtpModal from "../hooks/useBankAccountOtpModal";

function WalletAccount() {
    const types = ['wallet'];
    const [bankFilters,setBankFilters] = useState([]);
    const [open,setOpen] = useState(false);
    const [options,setOptions] = useState([]);
    const [form] = Form.useForm();
    const [, contextHolder] = message.useMessage();
    const [icon,setIcon] = useState('');
    const {setLoading} = useContext(LoadingContext);
    const [tableLoading,setTableLoading] = useState(false);
    const [dataSource,setDataSource] = useState([]);
    const [openModal,setOpenModal] = useState(false);
    const [qrCode,setQrCode] = useState('');
    const [openModalTransaction,setOpenModelTransaction] = useState(false);
    const [dataTransaction,setDataTransaction] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [formSearch] = Form.useForm();
    const [openDrawerTransfer,setOpenDrawerTransfer] = useState(false);
    const [bankTransfer,setBankTransfer] = useState([]);
    const [uuid,setUuid] = useState('');
    const [bankAccountId, setBankAccountId] = useState('');
    const [formTransfer] = Form.useForm();
    const [formDevice] = Form.useForm();
    const [openModalDevice, setOpenModalDevice] = useState(false);
    const [dataTransfer,setDataTransfer] = useState({});
    const {
        openModalOtp,
        otpUuid,
        otpInitialMessage,
        otpInitialMode,
        otpInitialQrCode,
        closeOtpModal,
        markOtpResolved,
        openOtpFromHandle
    } = useBankAccountOtpModal();
    const [, setWidthTable] = useState(2800);
    const [recordLoading, setRecordLoading] = useState({});
    const [openModalApprove, setOpenModalApprove] = useState(false);
    const [optionApproves, setOptionApproves] = useState([]);
    const [bankAccountIdApprove, setBankAccountIdApprove] = useState(null);
    const [uuidApprove, setUuidApprove] = useState('');
    const [openModalBankPrivate, setOpenModalBankPrivate] = useState(false);
    const [dataBankPrivate, setDataBankPrivate] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [optionQuery,setOptionQuery] = useState([]);
    const [query,setQuery] = useState('');
    const [formBankPrivate] = Form.useForm();
    const [bankAccountIdPrivate, setBankAccountIdPrivate] = useState('');
    const { styles } = useStyle();
    const [summaryData, setSummaryData] = useState({
        totalBalance: 0
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: (!types.includes('wallet') ? 50 : 10),
        }
    });
    const [viewMode, setViewMode] = useState(() => {
        const saved = localStorage.getItem('bankAccount.viewMode');
        return saved === 'list' || saved === 'grid' ? saved : 'grid';
    });

    const items =  [
        {
            name: 'username',
            placeholder: 'Tên đăng nhập',
            type: 'text'
        },
        {
            name: 'accountName',
            placeholder: 'Tên tài khoản',
            type: 'text'
        },
        {
            name: 'accountNumber',
            placeholder: 'Số tài khoản',
            type: 'text'
        }
    ]

    const mergedItems = [
        {
            key: 'GET_BALANCE',
            label: (
                <ItemDropDown icon={<FontAwesomeIcon icon={faArrowsRotate}/>}>
                    Làm mới số dư
                </ItemDropDown>
            ),
        },
        {
            key: 'GET_TRANSACTION',
            label: (
                <ItemDropDown icon={<TransactionOutlined/>}>
                    Truy vấn giao dịch
                </ItemDropDown>
            ),
        },
        {
            key: 'RE_LOGIN',
            label: (
                <ItemDropDown icon={<LoginOutlined/>}>
                    Đăng nhập
                </ItemDropDown>
            )
        },
        {
            key: 'REGISTER_SMART_OTP',
            type: 'wallet',
            label: (
                <ItemDropDown icon={<FontAwesomeIcon icon={faRegistered}/>}>
                    Đăng ký smart OTP
                </ItemDropDown>
            )
        },
        {
            key: 'SHOW_QR',
            label: (
                <ItemDropDown icon={<QrcodeOutlined/>}>
                    QR Code
                </ItemDropDown>
            )
        }
    ]

    const columns = [
        {
            title: 'Mã',
            dataIndex: 'bankName',
            filters: bankFilters,
            filterMode: 'tree',
            align: 'center',
            fixed: 'left',
            render: (value) => {
                return (
                    <Tag>{value}</Tag>
                )
            }
        },
        {
            title: 'Đối tác riêng',
            dataIndex: 'bankAccountPrivates',
            align: 'center',
            width: '200px',
            hidden: types.includes('wallet'),
            render: (value, record) => {
                return (
                    <Space>
                        {value.length === 0 && (
                            <Tag color={'default'}>ALL</Tag>
                        )}
                        {value.map((item, index) => (
                            <Tag color={'orange'} key={index}>{item.username}</Tag>
                        ))}
                        <Button onClick={() => handleClickEditBankPrivate(record)} type={'primary'} size={'small'} icon={<EditOutlined/>} title={'Sửa đối tác'}/>
                        <Button onClick={() => handleClickAddBankPrivate(record)} size={'small'} icon={<PlusOutlined/>} title={'Thêm đối tác'}/>
                    </Space>
                )
            }
        },
        {
            title: 'Loại tài khoản',
            dataIndex: 'type',
            align: 'center',
            filterMode: 'tree',
            editable: true,
            inputType: 'select',
            width: '120px',
            fixed: 'left',
            filters: [
                {
                    text: 'Nhận tiền',
                    value: 'in'
                },
                {
                    text: 'Chuyển tiền',
                    value: 'out'
                },
                {
                    text: 'Nhận và chuyển',
                    value: 'in_out'
                },
                {
                    text: 'Cho thuê',
                    value: 'hook'
                },
                {
                    text: 'Nhận tiền dồn',
                    value: 'main'
                }
            ],
            render: (value) => {
                return <BankAccountType type={value}/>
            }
        },
        {
            title: 'Cấp độ',
            dataIndex: 'level',
            align: 'center',
            width: '100px',
            hidden: !types.includes('wallet'),
            render: (value) => {
                const colorLevel = {
                    0 : 'red',
                    1 : 'red',
                    2 : 'red',
                    3 : 'red',
                    4 : 'red',
                    5 : 'green'
                }
                return <Tag color={colorLevel[value]}>Cấp {value}</Tag>
            }
        },
        {
            title: 'Tài khoản',
            dataIndex: 'username',
            width: '150px',
            align: 'center',
            hidden: false,
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Thông tin',
            dataIndex: 'accountInfo',
            align: 'center',
            width: '250px',
            fixed: 'left',
            render: (_,record) => {
                return (
                    <Flex vertical={true} justify={'center'} align={'center'} gap={'small'}>
                        <ReadMoreText text={record.accountName} maxLength={15}/>
                        <Typography.Paragraph
                            copyable={{
                                text: `${record.displayName}\n${record.accountNumber}\n${record.accountName}`
                            }}
                            style={{
                                margin: 0
                            }}
                        ><Tag>{record.accountNumber}</Tag></Typography.Paragraph>
                    </Flex>
                )
            }
        },
        {
            title: 'Số dư',
            dataIndex: 'balance',
            align: 'center',
            width: '130px',
            render: (value,record) => {
                return numberFormat(record.balance);
            },
            sorter: true
        },
        {
            title: 'Tổng nạp (ngày)',
            dataIndex: 'dailyReceiveAmount',
            width: '200px',
            sorter: true,
            render: (value,record) => {
                return <AmountLimit amount={record.dailyReceiveAmount} total={record.maxAmountLimitPerDay}/>
            }
        },
        {
            title: 'Tổng chuyển (ngày)',
            dataIndex: 'dailyTransferAmount',
            width: '200px',
            sorter: true,
            render: (value, record) => {
                return <AmountLimit amount={record.dailyTransferAmount} total={record.maxAmountLimitTransferPerDay}/>
            }
        },
        {
            title: 'Tổng nạp (tháng)',
            dataIndex: 'monthlyReceiveAmount',
            width: '200px',
            sorter: true,
            render: (value,record) => {
                return <AmountLimit amount={record.monthlyReceiveAmount} total={record.maxAmountLimitPerMonth}/>
            }
        },
        {
            title: 'Tổng chuyển (tháng)',
            dataIndex: 'monthlyTransferAmount',
            width: '200px',
            sorter: true,
            render: (value, record) => {
                return <AmountLimit amount={record.monthlyTransferAmount} total={record.maxAmountLimitTransferPerMonth}/>
            }
        },
        {
            title: 'Số GD nhận (ngày)',
            dataIndex: 'dailyTotalReceives',
            hidden: true,
            render: (value,record) => {
                return <CountLimit count={record.dailyTotalReceives} total={record.dailyReceiveLimit}/>
            },
            sorter: (a,b) => {
                return a.dailyTotalRecevies - b.dailyTotalRecevies
            }
        },
        {
            title: 'Số GD chuyển (ngày)',
            dataIndex: 'dailyTotalTransfers',
            hidden: true,
            render: (value,record) => {
                return <CountLimit count={record.dailyTotalTransfers} total={record.dailyTransferLimit}/>
            },
            sorter: (a,b) => {
                return a.dailyTotalTransfers - b.dailyTotalTransfers
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            width: '120px',
            filters: [
                {
                    text: 'Đóng',
                    value: false
                },
                {
                    text: 'Mở',
                    value: true
                }
            ],
            align: 'center',
            render: (value) => {
                if (value === true) {
                    return <Tag color={'green'}>OKE</Tag>
                }
                return <Tag color={'red'}>Lỗi</Tag>
            }
        },
        {
            title: 'Tự động rút',
            dataIndex: 'autoWithdrawalEnabled',
            width: '120px',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Đóng',
                    value: false
                },
                {
                    text: 'Mở',
                    value: true
                }
            ],
            align: 'center',
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Mở</Tag>
                }
                return <Tag color={'red'}>Đóng</Tag>
            }
        },
        {
            title: 'Hoạt động',
            dataIndex: 'state',
            editable: true,
            inputType: 'switch',
            align: 'center',
            width: '150px',
            filters: [
                {
                    text: 'Tắt',
                    value: 'disabled'
                },
                {
                    text: 'Bật',
                    value: 'active'
                }
            ],
            render: (value) => {
                if (value === 'disabled') {
                    return <Tag color={'red'}>Không hoạt động</Tag>
                }
                return <Tag color={'green'}>Hoạt động</Tag>
            }
        },
        {
            title: 'Đăng nhập tự động',
            dataIndex: 'autoReLoginEnabled',
            editable: true,
            inputType: 'switch',
            align: 'center',
            width: '150px',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Hoạt động</Tag>
                }
                return <Tag color={'red'}>Không hoạt động</Tag>
            }
        },
        {
            title: 'Tình trạng',
            dataIndex: 'stateAuth',
            inputType: 'switch',
            align: 'center',
            width: '150px',
            filters: [
                {
                    text: 'Bình thường',
                    value: 'none'
                },
                {
                    text: 'Bị khóa',
                    value: 'locked'
                },
                {
                    text: 'Xác thực OTP',
                    value: 'otp'
                },
                {
                    text: 'Sai mật khẩu',
                    value: 'password'
                }
            ],
            render: (value) => {
                if (value === 'locked') {
                    return <Tag color={'red-inverse'}>Bị khóa</Tag>
                } else if (value === 'otp') {
                    return <Tag color={'orange'}>Xác thực OTP</Tag>
                } else if (value === 'password') {
                    return <Tag color={'orange'}>Sai mật khẩu</Tag>
                } else {
                    return <Tag color={'green'}>Bình thường</Tag>
                }
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            fixed: 'right',
            render: (_,record) => {
                const items = mergedItems.flatMap((col) => {
                    if ((col.type && types.includes(col.type)) || !col.type) {
                        return [{
                            ...col,
                            onClick: () => handleAccount(record.uuid, col.key),
                        }];
                    }
                    return [];
                });
                const editable = isEditing(record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => save(record.uuid)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancel}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <Space>
                        <Dropdown.Button
                            placement={'bottom'}
                            menu={{
                                items
                            }}
                            type={'default'}
                            disabled={editingKey !== ''}
                            onClick={() => edit(record)}
                            title={'Chỉnh sửa'}
                        >
                            <EditOutlined/>
                        </Dropdown.Button>
                        <Button onClick={() => handleClickTransfer(record)} icon={<FontAwesomeIcon icon={faMoneyBillTransfer}/>} title={'Chuyển tiền'}/>
                        {record.bankType !== 'wallet' && (
                            <Button loading={!!recordLoading[record.uuid]} onClick={() => handleClickDevice(record)} type={'primary'} icon={<MobileOutlined/>} title={'Thiết bị'}/>
                        )}
                        {record.bankType === 'business' && (
                            <Button loading={!!recordLoading[record.uuid]} onClick={() => handleOpenApprove(record.uuid)} type={'primary'} icon={<AccountBookOutlined/>} title={'Tài khoản duyệt'}/>
                        )}
                        <Popconfirm
                            title="Xóa tài khoản"
                            description="Bạn muốn xóa tài khoản này?"
                            onConfirm={() => handleDeleteBankAccount(record.uuid)}
                            okText="Yes"
                            cancelText="No"
                            icon={<CheckOutlined/>}
                        >
                            <Button loading={!!recordLoading[record.uuid]} danger={true} type={'dashed'} icon={<FontAwesomeIcon icon={faTrash}/>} title={'Xóa tài khoản'}/>
                        </Popconfirm>
                    </Space>
                )
            }
        }
    ];

    const itemTransfer = [
        {
            name: 'accountNumber',
            placeholder: 'Nhập số tài khoản',
            type: 'text',
            label: 'Số tài khoản',
            required: true
        },
        {
            name: 'amount',
            placeholder: 'Nhập số tiền',
            type: 'number',
            label: 'Số tiền',
            required: true
        },
        {
            name: 'bankCode',
            placeholder: 'Chọn ngân hàng',
            type: 'select',
            label: 'Ngân hàng nhận',
            required: true,
            options: (bankTransfer).map((item) => {
                return {
                    value:  item.bankCode,
                    label: `${item.bankName} - ${item.displayName} (${item.shortName})`
                }
            })
        },
        {
            name: 'accountName',
            placeholder: 'Nhập tên người nhận',
            type: 'text',
            label: 'Tên người nhận',
            required: true,
            disabled: true
        },
        {
            name: 'comment',
            placeholder: 'Nhập nội dung',
            type: 'text',
            label: 'Nội dung',
            required: false
        },
        {
            name: 'challenge',
            placeholder: 'Mã giao dịch để lấy OTP',
            type: 'text',
            label: 'Mã giao dịch',
            disabled: true
        },
        {
            name: 'otp',
            placeholder: 'Nhập mã OTP',
            type: 'text',
            label: 'Mã OTP',
        }
    ];

    const handleClickTransfer = (record) => {
        setOpenDrawerTransfer(true);
        setUuid(record.uuid);
    }

    const handleSearchPartner = (value) => {
        setQuery(value);
    }

    const handleClickAddBankPrivate = (record) => {
        setIsModalVisible(true);
        setBankAccountIdPrivate(record.bankAccountId);
    }

    const handleSubmitAddPartner = async (values) => {
        const data = {
            bankAccountId: bankAccountIdPrivate,
            userIds: values.userIds
        }
        const response = await addPartner( data);
        if (response.success) {
            message.success('Thêm đối tác cho tài khoản ngân hàng thành công.');
        } else {
            message.error(response.message);
        }
    }

    const handleDeleteBankAccountPrivate = async (id) => {
        const response = await deleteBankAccountPrivate( id);
        if (response.success) {
            message.success('Xóa thành công vui lòng làm mới lại trang.');
        } else {
            message.error(response.message);
        }
    }

    const handleClickEditBankPrivate = async (record) => {
        const response = await getBankAccountPrivate( record.bankAccountId);
        if (response.success) {
            setOpenModalBankPrivate(true);
            setDataBankPrivate(response.data);
        }
    }

    const handleOpenApprove = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await getBankAccountBusiness( uuid);
        if (response.success) {
            const optionData = response.data.map((item) => {
                return {
                    value: item.bankAccountId,
                    label: `(${item.bankName}) ${item.username} - ${item.accountNumber}`
                }
            });
            setUuidApprove(uuid);
            setOptionApproves(optionData);
            setOpenModalApprove(true);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleConfirmApprove = async () => {
        const response = await confirmBankAccountApprove( uuidApprove, bankAccountIdApprove);
        if (response.success) {
            message.success('Thêm tài khoản duyệt thành công');
        } else {
            message.error(response.message);
        }
    }

    const handleDeleteBankAccount = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await deleteBankAccount( uuid);
        if (response.success) {
            const newData = [...dataSource];
            const index = newData.findIndex((item) => uuid === item.uuid);
            newData.splice(index, 1);
            setDataSource(newData);
            message.success('Xóa tài khoản thành công');
        } else {
            message.error(response.message)
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleClickDevice = async (record) => {
        setRecordLoading(prev => ({ ...prev, [record.uuid]: true }));
        formDevice.setFieldsValue({
            deviceName: '',
            deviceId: '',
            pin: '',
            platformVersion: ''
        })
        const response = await getBankAccountDevice( record.bankAccountId);
        if (response.success && response.data) {
            formDevice.setFieldsValue({
                deviceName: response.data?.deviceName,
                deviceId: response.data?.deviceId,
                pin: response.data?.pin,
                platformVersion: response.data?.platformVersion
            })
        }
        setOpenModalDevice(true);
        setBankAccountId(record.bankAccountId);
        setRecordLoading(prev => ({ ...prev, [record.uuid]: false }));
    }

    const handleSubmitDevice = async (values) => {
        setLoading(true);
        const response = await updateBankAccountDevice( bankAccountId, values);
        if (response.success) {
            message.success('Cập nhật thiết bị thành công');
        }
        else {
            message.error(response.message);
        }
        setLoading(false);
    }

    const handleSubmitTransfer = async (values) => {
        try {
            setLoading(true);
            const response = await transfer( uuid, {
                data: dataTransfer,
                ...values
            });
            if (response.success) {
                if (response.data.otp) {
                    setDataTransfer(response.data.data);
                    if (response.data.data.challenge) {
                        formTransfer.setFieldValue('challenge', response.data.data.challenge);
                    }
                    message.info('Vui lòng nhập mã OTP để xác nhận chuyển tiền');
                }
                else {
                    message.success('Chuyển tiền thành công!');
                }
            } else {
                message.error(response.message);
            }
        } catch (error) {
            message.error('Đã xảy ra lỗi trong quá trình chuyển tiền.');
        } finally {
            setLoading(false);
        }
    };

    const handleChangeTransfer = async (e) => {
        if (typeof e === 'string' || e.target.id === 'accountNumber') {
            const accountNumber = formTransfer.getFieldValue('accountNumber');
            const bankCode = formTransfer.getFieldValue('bankCode');
            if (bankCode && bankCode.length > 0) {
                const response = await getBenchName( uuid, {
                    accountNumber: accountNumber,
                    bankCode: bankCode
                });
                if (response.success) {
                    formTransfer.setFieldValue('accountName', response.data.benchName);
                }
                else {
                    message.error(response.message);
                }
            }
        }
    }

    const cancel = () => {
        setEditingKey('');
    };

    const save =  async (uuid) => {
        setTableLoading(true);
        try {
            const row = await form.validateFields();
            const newData = [...dataSource];
            const index = newData.findIndex((item) => uuid === item.uuid);
            const data = {
                ...row,
                uuid: uuid
            };
            const response = await updateBankAccount(data);
            if (response.success) {
                if (index > -1) {
                    const item = newData[index];
                    newData.splice(index, 1, {
                        ...item,
                        ...response.data
                    });
                    setDataSource(newData);
                    setEditingKey('');
                } else {
                    console.log(row);
                    newData.push(row);
                    setDataSource(newData);
                    setEditingKey('');
                }
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
            setTableLoading(false);
        }
    }

    const edit = (record) => {
        form.setFieldsValue({
            ...record,
            state: record.state === 'active'
        });
        setEditingKey(record.uuid);
    };

    const updateData = (uuid,data = {}) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => uuid === item.uuid);
        if (index > -1) {
            const item = newData[index];
            newData.splice(index, 1, {
                ...item,
                ...data
            });
            setDataSource(newData);
        } else {
            newData.push(data);
            setDataSource(newData);
        }
    }

    const handleAccount = (uuid, cmd) => {
        const fetchData = async () => {
            setTableLoading(true);
            try {
                const response = await handle(uuid, cmd);
                if (response.success) {
                    if (cmd === 'RE_LOGIN') {
                        openOtpFromHandle(uuid, response.data || response);
                    }
                    switch (cmd) {
                        case 'GET_BALANCE':
                        case 'RE_LOGIN':
                            updateData(uuid,response.data);
                            break;
                        case 'GET_TRANSACTION':
                            setOpenModelTransaction(true);
                            setDataTransaction(response.data);
                            setUuid(uuid);
                            break;
                        case 'SHOW_QR':
                            setOpenModal(true);
                            setQrCode(response.data.text);
                            setIcon(response.data.icon);
                            break;
                        default:
                            break;
                    }
                } else if (cmd === 'RE_LOGIN') {
                    message.error(response.message || 'Đăng nhập lại thất bại');
                }
            }
            catch (e) {
                if (cmd === 'RE_LOGIN') {
                    message.error('Đăng nhập lại thất bại');
                }
            }
            setTableLoading(false);
        }
        fetchData();
    }

    const fetchDataBankAccount = async () => {
        setTableLoading(true);
        const response = await getBankAccounts({
            ...tableParams,
            types: types
        });
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalBalance: response.data.totalBalance
            })
        }
        setTableLoading(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            sorter,
        });
        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
            setDataSource([]);
        }
    };

    const isEditing = (record) => record.uuid === editingKey;

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
                filters: col.filters ?? []
            }),
        };
    });

    const handleSearch = () => {
        const params = formSearch.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        });
    }

    const handleRefresh = async () => {
        await fetchDataBankAccount();
    }

    useEffect(() => {
        fetchDataBankAccount().finally();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams?.sorter,
        tableParams?.search,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.pagination?.pageSize),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.pagination?.current)
    ]);

    useEffect(() => {
        const params = tableParams;
        const pageSize = (!types.includes('wallet') ? 50 : 10);
        if (params.pagination.pageSize !== pageSize) {
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    pageSize: (!types.includes('wallet') ? 50 : 10)
                }
            });
        }
        setWidthTable((!types.includes('wallet') ? 2000 : 1800))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [types]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getBankTransfer();
            if (response.success) {
                setBankTransfer(response.data);
            }
        }
        fetchData().finally();
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchPartners = async () => {
            const response = await searchPartner(query);
            if (response.success) {
                setOptionQuery(response.data)
            }
        }
        fetchPartners().finally(setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const response = await getBanks( types);
            if (response.success) {
                const filters = response.data.map(item => ({
                    text: item.displayName,
                    value: item.bankName
                }));
                const radios = response.data.map((item) => ({
                    icon: item.icon,
                    value: item.bankName,
                    label: item.displayName,
                    title: item.displayName
                }))
                setBankFilters(filters);
                setOptions(radios);
            }
            setLoading(false);
        }
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {contextHolder}
            <Page title="Ví điện tử">
                <Flex
                    justify={'space-between'}
                    align={'center'}
                    wrap={'wrap'}
                    gap={12}
                    style={{
                        marginBottom: 16,
                    }}
                >
                    <Space>
                        <Button type={'primary'} onClick={() => setOpen(true)} icon={<FontAwesomeIcon icon={faAdd}/>}>Thêm tài khoản</Button>
                        <Button type={'primary'} icon={<ExportOutlined/>}>Xuất file</Button>
                        <Button type={'default'} onClick={() => handleRefresh()} icon={<ReloadOutlined/>}>Làm mới</Button>
                    </Space>
                    <Segmented
                        value={viewMode}
                        onChange={(value) => {
                            setViewMode(value);
                            localStorage.setItem('bankAccount.viewMode', value);
                        }}
                        options={[
                            {
                                label: 'Lưới',
                                value: 'grid',
                                icon: <AppstoreOutlined />
                            },
                            {
                                label: 'Danh sách',
                                value: 'list',
                                icon: <UnorderedListOutlined />
                            }
                        ]}
                    />
                </Flex>
                <Search
                    form={formSearch}
                    items={items}
                    onSearch={handleSearch}
                />
                <Form
                    form={form}
                    component={false}
                >
                    {viewMode === 'list' ? (
                        <Table
                            className={styles.customTable}
                            rowKey={'uuid'}
                            columns={mergedColumns}
                            bordered={true}
                            scroll={{
                                x: 'max-content',
                                y: 1000
                            }}
                            loading={tableLoading}
                            dataSource={dataSource}
                            onChange={handleTableChange}
                            pagination={tableParams.pagination}
                            components={{
                                body: {
                                    cell: EditTableCell
                                }
                            }}
                            summary={() => {
                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} colSpan={5}>
                                            Tổng số dư
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={1} align={'center'} colSpan={1}>
                                            <Tag color={'blue'}>{numberFormat(summaryData.totalBalance)}</Tag>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }}
                        />
                    ) : (
                        <BankAccountGrid
                            dataSource={dataSource}
                            loading={tableLoading}
                            options={options}
                            types={types}
                            filters={tableParams.filters || {}}
                            onFiltersChange={(nextFilters) => {
                                setTableParams({
                                    ...tableParams,
                                    filters: nextFilters,
                                    pagination: {
                                        ...tableParams.pagination,
                                        current: 1,
                                    },
                                });
                            }}
                            pagination={tableParams.pagination}
                            onPaginationChange={(current, pageSize) => {
                                handleTableChange(
                                    {
                                        ...tableParams.pagination,
                                        current,
                                        pageSize
                                    },
                                    tableParams.filters,
                                    tableParams.sorter
                                );
                            }}
                            summaryBalance={summaryData.totalBalance}
                            renderActions={(record) => {
                                const operation = columns.find((col) => col.dataIndex === 'operation');
                                return operation?.render(null, record);
                            }}
                            onEditPrivate={handleClickEditBankPrivate}
                            onAddPrivate={handleClickAddBankPrivate}
                        />
                    )}
                </Form>
                <Modal
                    open={openModal}
                    onCancel={() => setOpenModal(false)}
                    title={'Hiển thị mã QR CODE'}
                    footer={null}
                >
                    <Flex
                        justify={'center'}
                        align={'center'}
                    >
                        <QRCode
                            value={qrCode}
                            size={300}
                            icon={icon}
                        />
                    </Flex>
                </Modal>
                <BankAccountTransaction
                    open={openModalTransaction}
                    setOpen={setOpenModelTransaction}
                    dataSource={dataTransaction}
                    uuid={uuid}
                />
                <Modal
                    open={openModalDevice}
                    onOk={formDevice.submit}
                    onCancel={() => setOpenModalDevice(false)}
                    title={'Cài đặt thiết bị liên kết'}
                    okText={'Xác nhận'}
                >
                    <Form
                        layout={'vertical'}
                        form={formDevice}
                        onFinish={handleSubmitDevice}
                    >
                        <Form.Item
                            name={'deviceName'}
                            label={'Tên thiết bị'}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name={'deviceId'}
                            label={'ID thiết bị'}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name={'platformVersion'}
                            label={'Phiên bản Android'}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name={'pin'}
                            label={'Mã pin'}
                        >
                            <Input.Password/>
                        </Form.Item>
                    </Form>
                </Modal>
                <BankAccountOtpModal
                    open={openModalOtp}
                    uuid={otpUuid}
                    initialMessage={otpInitialMessage}
                    initialOtpMode={otpInitialMode}
                    initialQrCode={otpInitialQrCode}
                    onCancel={closeOtpModal}
                    onSuccess={() => {
                        markOtpResolved();
                        fetchDataBankAccount();
                    }}
                />
                <Modal
                    title={'Liên kết tài khoản duyệt'}
                    open={openModalApprove}
                    onOk={handleConfirmApprove}
                    onCancel={() => setOpenModalApprove(false)}
                    okText={'Xác nhận'}
                    width={800}
                >
                    <Select
                        style={{
                            width: '100%',
                        }}
                        onChange={(value) => setBankAccountIdApprove(value)}
                        options={optionApproves}
                    />
                </Modal>
                <Modal
                    title={'Thêm đối tác riêng'}
                    open={isModalVisible}
                    onOk={formBankPrivate.submit}
                    onCancel={() => setIsModalVisible(false)}
                >
                    <Form
                        style={{
                            marginBottom: "16px"
                        }}
                        layout={'vertical'}
                        form={formBankPrivate}
                        onFinish={handleSubmitAddPartner}
                    >
                        <Form.Item
                            name={'userIds'}
                            label={'Đối tác'}
                        >
                            <Select
                                mode={'multiple'}
                                showSearch
                                placeholder={'Đối tác'}
                                defaultActiveFirstOption={false}
                                suffixIcon={<SearchOutlined/>}
                                filterOption={false}
                                notFoundContent={null}
                                onSearch={handleSearchPartner}
                                options={(optionQuery || []).map((d) => ({
                                    value: d.userId,
                                    label: d.name,
                                }))}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title={'Chỉnh sửa đối tác riêng'}
                    open={openModalBankPrivate}
                    onCancel={() => setOpenModalBankPrivate(false)}
                    okText={'Xác nhận'}
                    width={800}
                >
                    <Table
                        dataSource={dataBankPrivate}
                        columns={[
                            {
                                title: 'Tên đối tác',
                                dataIndex: 'username',
                                align: 'center'
                            },
                            {
                                title: 'Ngày thêm',
                                dataIndex: 'createdAt',
                                align: 'center',
                                render: (value) => {
                                    return formatDateTime(value)
                                }
                            },
                            {
                                title: 'Hành động',
                                dataIndex: 'operation',
                                render: (_, record) => {
                                    return (
                                        <Space>
                                            <Popconfirm
                                                title={'Xóa bỏ'}
                                                description="Bạn muốn xóa đối tác sử dụng tài khoản ngân hàng này?"
                                                onConfirm={() => handleDeleteBankAccountPrivate(record.id)}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button danger={true} icon={<DeleteOutlined/>} title={'Xóa'}/>
                                            </Popconfirm>
                                        </Space>
                                    )
                                }
                            }
                        ]}
                    />
                </Modal>
                    <FormDrawer
                        width={600}
                        title={'Chuyển tiền'}
                        open={openDrawerTransfer}
                        onClose={() => setOpenDrawerTransfer(false)}
                        items={itemTransfer}
                        onSubmit={handleSubmitTransfer}
                        onChange={handleChangeTransfer}
                        form={formTransfer}
                    />
            </Page>
            <BankAccountAuthModal
                open={open}
                onClose={() => setOpen(false)}
                onSuccess={() => {
                    fetchDataBankAccount();
                }}
                bankOptions={options}
            />
        </>
    )
}

export default WalletAccount;
